/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import { useSnackbar } from 'notistack';

import CheckmarkIcon from 'app/assets/icons/checkmark-2.svg?react';

function getBackgroundColor({ value, disabled }) {
  if (value && !disabled) return '#327D5D';
  if (value && disabled) return '#B7DECC';
  if (!value && !disabled) return '#C2C5CD';
  return '#E0E2E8';
}

export default function Switch({
  value,
  onChange,
  disabled = false,
  disabledMessage = 'Switch is disabled',
}) {
  const { enqueueSnackbar } = useSnackbar();

  function handleSumbit() {
    if (disabled) {
      enqueueSnackbar(disabledMessage, { variant: 'error' });
      return;
    }

    onChange(!value);
  }

  return (
    <div
      style={{
        backgroundColor: getBackgroundColor({ value, disabled }),
        cursor: disabled ? 'default' : 'pointer',
      }}
      className="relative w-40 h-24 rounded-full transition"
      onClick={handleSumbit}
      title={disabled ? disabledMessage : undefined}
    >
      <div
        style={{ transform: value ? 'translate(16px)' : 'translate(0px)' }}
        className="absolute top-2 left-2 w-20 h-20 rounded-full bg-white transition-all shadow-elevation-1 flex justify-center items-center"
      >
        {value && <CheckmarkIcon className="text-typography-success" />}
      </div>
    </div>
  );
}
